import React from 'react';
import PropTypes from 'prop-types';
import { Person, PersonType } from '../../../components/person';
import { formatDateTime, normalizeNotifiedRecipient } from '../voucher-verify-utils';

const ConfirmationScreen = ({
  verifiedAt, notifiedRecipients, onBack, onDone,
}) => (
  <div className="verify-confirmation">
    <h2>Voucher successfully validated</h2>

    <div className="confirmation-meta">
      <span className="meta-label">Time Submitted</span>
      <span className="meta-value">{formatDateTime(verifiedAt)}</span>
    </div>

    <p className="notified-label">We let the following people know you have validated this voucher.</p>

    {notifiedRecipients.map((person) => {
      const recipient = normalizeNotifiedRecipient(person);
      const key = recipient.employee_id
        || recipient.email
        || recipient.work_email
        || `${recipient.first_name || ''}-${recipient.last_name || ''}-${recipient.name || ''}`;
      return (
        <div key={key} className="notified-person">
          <Person
            person={recipient}
            type={PersonType.MEMBER}
            sizing="lg"
            hoverAlign="left"
          />
        </div>
      );
    })}

    <div className="confirmation-actions">
      <button className="btn-back" type="button" onClick={onBack}>BACK</button>
      <button className="btn-done" type="button" onClick={onDone}>DONE</button>
    </div>
  </div>
);

ConfirmationScreen.propTypes = {
  verifiedAt: PropTypes.string.isRequired,
  notifiedRecipients: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    first_name: PropTypes.string,
    firstName: PropTypes.string,
    last_name: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.string,
    image: PropTypes.string,
    avatar_url: PropTypes.string,
    profile_image: PropTypes.string,
    profile_image_url: PropTypes.string,
  })).isRequired,
  onBack: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default ConfirmationScreen;
